import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spin } from "antd";
import Lottie from "lottie-react";
import ReactConfetti from "react-confetti";
import { useWindowSize } from "react-use";
import successAnimation from "../../assets/success.json";
import pendingAnimation from "../../assets/pending.json";
import failedAnimation from "../../assets/failed.json";

function OrderStatusSmartClinic() {
  const navigate = useNavigate();
  const location = useLocation();
  const { width, height } = useWindowSize();

  const [loading, setLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [txnId, setTxnId] = useState("");
  const [patientName, setPatientName] = useState("");

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const orderId = params.get("orderId");

    if (!orderId) return;

    const fetchOrderStatus = async () => {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      try {
        const response = await fetch(
          `${API_URL}orders/get-orderById?orderId=${orderId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
          }
        );

        const result = await response.json();
        console.log(result,"sdfcgvhbj")
        if (result.status === 200 && result.data) {
          const { paymetStatus, txnId, patientName } = result.data;
          const status = paymetStatus?.toLowerCase();

          setPaymentStatus(status);
          setPatientName(patientName || "Patient"); // fallback
          setTxnId(txnId || "");
          setRemarks(
            `Dear ${
              patientName || "Patient"
            }, we appreciate your trust. Your health is our priority.`
          );
          setLoading(false);

          localStorage.setItem("paymentStatus", status);
          localStorage.setItem("trancationid", txnId || "");
          localStorage.setItem("paymentRemarks", remarks);
        }
      } catch (error) {
        console.error("Error fetching order status:", error);
      }
    };

    fetchOrderStatus();
  }, [location.search, navigate]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin tip="Please wait..." size="large">
          <div className="w-28 h-4" />
        </Spin>
      </div>
    );
  }

  const baseContainer =
    "flex justify-center items-center h-screen relative overflow-hidden";
  const baseCard =
    "relative p-1 rounded-2xl shadow-2xl bg-white max-w-sm w-full text-center animate-fadeIn";

  const renderCard = (
    bgGradient,
    animationData,
    title,
    titleColor,
    btnColor
  ) => (
    <div className={`${baseContainer} ${bgGradient}`}>
      <div className={baseCard}>
        <div className="relative z-10 p-8">
          <Lottie
            animationData={animationData}
            autoplay
            loop={false}
            style={{ height: 150 }}
          />
          <h1 className={`text-3xl font-bold ${titleColor} mt-4`}>{title}</h1>
          <p className="text-gray-500 font-semibold mt-2 text-sm">{remarks}</p>
          <button
            className={`mt-6 px-6 py-2 text-white font-semibold rounded-md shadow transition-all ${btnColor} hover:scale-105`}
            onClick={() => navigate("/dashboard")}
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );

  if (paymentStatus === "completed") {
    return (
      <div className="flex justify-center items-center h-screen bg-gradient-to-br from-[#004276] to-[#3cba84] relative overflow-hidden">
        <ReactConfetti
          width={width}
          height={height}
          recycle={false}
          numberOfPieces={250}
          colors={["#22c55e", "#16a34a", "#4ade80"]}
        />
        {renderCard(
          "", // no need for bgGradient as it's wrapped
          successAnimation,
          "Your payment has been processed successfully.",
          "text-[#004276]",
          "bg-gradient-to-r from-[#004172] to-[#3cba84]"
        )}
      </div>
    );
  }

  if (paymentStatus === "pending") {
    return renderCard(
      "bg-gradient-to-br from-yellow-200 to-yellow-400",
      pendingAnimation,
      "Payment Pending",
      "text-yellow-800",
      "bg-yellow-500"
    );
  }

  if (paymentStatus === "fail") {
    return renderCard(
      "bg-gradient-to-br from-red-100 to-red-400",
      failedAnimation,
      "Payment Failed. Please try again.",
      "text-red-700",
      "bg-red-600"
    );
  }

  return null;
}

export default OrderStatusSmartClinic;
